import React from 'react';

interface QuestionIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const QuestionIcon: React.FC<QuestionIconProps> = ({
  className = '',
  color = '#A2876E',
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M7 3.17578C5.60011 3.17578 4.40241 3.6308 3.55371 4.47949C2.70509 5.32818 2.25 6.52596 2.25 7.92578V13.9258C2.25004 15.3256 2.70505 16.5234 3.55371 17.3721C4.4024 18.2207 5.60016 18.6758 7 18.6758C7.13386 18.6758 7.25 18.7919 7.25 18.9258V21.0557C7.25003 21.4482 7.51615 21.64 7.62305 21.7041C7.78682 21.8023 8.09578 21.8862 8.4082 21.6875L8.41699 21.6816L12.8672 18.7217C12.912 18.6918 12.9666 18.6758 13.0098 18.6758H17.0098C18.4095 18.6758 19.6074 18.2206 20.4561 17.3721C21.3047 16.5234 21.7597 15.3256 21.7598 13.9258V7.92578C21.7598 6.52589 21.3047 5.32819 20.4561 4.47949C19.6074 3.6308 18.4097 3.17578 17.0098 3.17578H7ZM12 14.0957C12.1339 14.0957 12.25 14.2118 12.25 14.3457C12.2499 14.4839 12.1395 14.5957 12 14.5957C11.8605 14.5957 11.7501 14.4839 11.75 14.3457C11.75 14.2118 11.8661 14.0957 12 14.0957ZM12 7.10547C13.0538 7.10557 13.9102 7.96181 13.9102 9.01562C13.9102 9.87166 13.2924 10.3094 12.9824 10.5195C12.7752 10.6577 12.5853 10.8061 12.4521 10.9922C12.3023 11.2015 12.25 11.4204 12.25 11.6455V11.8555C12.25 11.9949 12.1381 12.1054 12 12.1055C11.8661 12.1055 11.75 11.9893 11.75 11.8555V11.6455C11.7501 10.7705 12.3743 10.3328 12.6992 10.1094L12.7002 10.1104C12.899 9.97604 13.0811 9.83091 13.21 9.65137C13.3543 9.45019 13.4102 9.23725 13.4102 9.01562C13.4102 8.23959 12.7761 7.60557 12 7.60547C11.2238 7.60547 10.5898 8.23953 10.5898 9.01562C10.5898 9.14948 10.4737 9.26562 10.3398 9.26562C10.206 9.26562 10.0898 9.14948 10.0898 9.01562C10.0898 7.96175 10.9462 7.10547 12 7.10547ZM6.75 19.1943L6.30078 19.1484C4.90384 19.005 3.77458 18.4239 2.99316 17.5361C2.21101 16.6475 1.75001 15.4199 1.75 13.9355V7.93555C1.75 6.33009 2.28679 5.02571 3.18848 4.12402C4.09016 3.22234 5.39454 2.68555 7 2.68555H17C18.6055 2.68555 19.9098 3.22234 20.8115 4.12402C21.7132 5.02571 22.25 6.33009 22.25 7.93555V13.9355C22.25 15.541 21.7132 16.8454 20.8115 17.7471C19.9098 18.6487 18.6054 19.1855 17 19.1855H13.0781L8.69238 22.1094C8.485 22.2443 8.24184 22.3154 8 22.3154C7.80134 22.3154 7.59312 22.2651 7.40723 22.165L7.40332 22.1631L7.25977 22.0742C6.94318 21.8451 6.75 21.4682 6.75 21.0654V19.1943Z"
        fill="#0C0E21"
        stroke={color}
      />
    </svg>
  );
};

export default QuestionIcon;
